<template>
  <div>
    <v-container
      fill-height
      v-if="$store.state.menu.Raffles"
      fluid
      grid-list-xl
    >
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Список розыгрышей" text="DTE">
            <v-btn color="primary" class="mr-2" @click="getRaffles(false)" text>
              Обновить
            </v-btn>

            <v-btn
              color="success"
              class="mr-2"
              @click="raffleAddModal = true"
              text
            >
              Добавить
            </v-btn>

            <div class="mt-2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск..."
                class="sticky search"
                :loading="loadingSearch"
                single-line
                hide-details
                clearable="true"
              ></v-text-field>
            </div>

            <v-data-table :headers="headers" :items="rafflesList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td class="text-xs-left">
                  {{ item.id }}
                </td>
                <td class="text-xs-left min-width">
                  {{ item.title }}
                </td>
                <td class="text-xs-left">
                  <span v-if="item.vendor">{{ item.vendor.title }}</span>
                  <span v-else>Вендор не установлен</span>
                </td>
                <td class="text-xs-left">
                  <span v-if="item.count_products">{{
                    item.count_products
                  }}</span>
                  <span v-else>0</span>
                </td>

                <td class="text-xs-left">
                  <span
                    class="text-warning"
                    v-if="item.is_active && item.is_active === 1"
                    >Да
                  </span>
                  <span class="text-warning" v-else>Нет </span>
                </td>

                <td class="text-xs-left">
                  <span v-if="item.before_at">{{
                    item.before_at | dateTime
                  }}</span>
                  <span v-else>Не указан еще</span>
                </td>
                <td class="text-xs-right min-width100">
                  <v-icon @click="openRaffle(item.id)">mdi-pencil</v-icon>
                </td>
              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      width="600"
      persistent
      transition="dialog-bottom-transition"
      v-model="raffleAddModal"
    >
      <v-card>
        <v-card-text>
          <div class="body-2 mb-2">Название акции</div>
          <v-text-field
            v-model="raffle_title"
            label="Введите модель"
            hide-details
          >
          </v-text-field>
          <br />
          <br />
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="addRaffle">Добавить акцию </v-btn>
          <v-btn color="primary" text @click="raffleAddModal = false"
            >Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      fullscreen
      hide-overlay
      v-if="raffleID"
      v-model="raffleID"
    >
      <RaffleCard :raffleID="raffleID" :closeRaffle="closeRaffle" />
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";

import { mapMutations, mapState } from "vuex";
import Raffle from "../components/core/Raffles/Raffle";
import RaffleCard from "../components/RaffleCard";

export default {
  data: () => ({
    raffle_title: "",
    raffleAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "Номер акции",
        value: "id",
      },
      {
        sortable: false,
        text: "Название",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Организатор",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Количество серийников",
        value: "total",
      },
      {
        sortable: false,
        text: "Активен",
        value: "total",
      },
      {
        sortable: false,
        text: "Окончание акции",
        value: "created_at",
      },
      {
        sortable: false,
        text: "",
        value: "",
        align: "right",
      },
    ],
    rafflesList: [],
    raffleID: null,
  }),
  components: { RaffleCard, Raffle, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getRaffles();
      }
    },
    getRaffles(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/raffles/list", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.rafflesList = response.data.data;
          this.last_page = response.data.last_page;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },
    openRaffle(raffleID) {
      this.raffleID = raffleID;
    },

    closeRaffle(update) {
      if (update) {
        this.getRaffles(false);
      }
      this.raffleID = null;
    },

    addRaffle() {
      if (this.raffle_title) {
        axios
          .post("admin/raffles/set", {
            title: this.raffle_title,
          })
          .then((response) => {
            if (response.data) {
              this.getRaffles(true);
              this.openRaffle(response.data.id);
              this.raffle_title = "";
            }
            this.$toast.success({
              title: "Успешно добавно",
              message: "Добавлена новая акция.",
            });
          })
          .catch((error) => {
            let data = error.response.data;
            if (data.errors) {
              let k = 0;
              Object.keys(data.errors).forEach((item) => {
                let err = data.errors[item];
                k++;
                for (let i = 0; i < err.length; i++) {
                  setTimeout(() => {
                    this.$toast.error({
                      title: "Ошибка",
                      message: err[i],
                    });
                  }, 100 * k);
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.raffleAddModal = false;
          });
      } else {
        this.$toast.error({
          title: "Заголовок",
          message: "Введите заголовок",
        });
      }
    },
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getRaffles(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getRaffles();
      }, 300);
    },
    language(val) {
      if (val) {
        this.getRaffles();
      }
    },
  },

  mounted() {
    this.getRaffles();
  },
  computed: {
    ...mapState(["language"]),
  },
};
</script>
